module.exports = __webpack_public_path__ + "img/symbol_7.03e8a983.png";